define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/heading/_base",
	"csi/heading/Time",
	"csi/types",
	"csi/widget/TimeTextBox",
	"csi/xml"
], function(declare, lang, csiHeading, Time, types, TimeTextBox, xml) {

	return declare(Time, {
		// from query perspective, treat time as number (not RANGE)
		queryOps: csiHeading.QUERY_OPS[xml.ATTR_DOUBLE],

		toHtmlDynamic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*Object*/params) {
			// summary: render editable	control for attribute
			this._addDynamicParams(ctx, h, params);
			return new TimeTextBox(params);
		},

		_setConstraints: function() {
			// summary: setup time constraints
			var c = this._constraints = lang.delegate(types.getTimeFormatOptions(types.FORMAT_TIME));
			if (this.minTime) c.min = this.minTime;
			if (this.maxTime) c.max = this.maxTime;
		}
	});
});